<template>
    <div class="content">
        <div class="row">
            <div class="col-md-12">
                <a-card>
                    <form @submit.prevent="addData($event)">
                        <div class="row">
                            <a-divider>تنظیمات سئو</a-divider>

                            <div class="col-md-6 my-1">
                                <div class="form-group ">
                                    <label>عنوان سئو سایت</label>
                                    <input type="text" name="title_seo" v-model="info.title_seo" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-6 my-1">
                                <div class="form-group ">
                                    <label> کلمات کلیدی </label>
                                    <input type="text" name="keywords" v-model="info.keywords" class="form-control" />
                                </div>
                            </div>

                        

                            <div class="col-md-12 my-5">
                                <div class="form-group ">
                                    <label>توضیحات سئو سایت</label>
                                    <b-form-textarea name="description_seo" id="textarea" v-model="info.description_seo" placeholder="توضیحات ..."
                                        rows="3" max-rows="6"></b-form-textarea>
                                </div>

                            </div>

                            <a-divider>تنظیمات مالی</a-divider>

                            <div class="col-md-6 my-1">
                                <div class="form-group ">
                                    <label>  درصد سود عادی ماهیانه</label>
                                    <input type="number" name="profit_percent" v-model="info.profit_percent" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-6 my-1">
                                <div class="form-group ">
                                    <label>هزینه ارسال هر پیامک تبلیغاتی</label>
                                    <input type="number" name="sms_cost" v-model="info.sms_cost" class="form-control" />
                                </div>
                            </div>
                            


                        </div>
                        <div class="card-footer  ">
                            <div class="row ">
                                <div class="col-md-10"></div>
                                <div class="col-md-1 ">
                                    <button type="submit" class="btn btn-fill btn-outline-success w-100">
                                        ذخیره
                                    </button>
                                </div>
                                
                                <div class="col-md-1 ">
                                    <router-link to="/categories/list" class="btn btn-fill btn-outline-danger w-100">
                                        بازگشت</router-link>
                                </div>

                            </div>

                        </div>
                    </form>
                </a-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                info: {
                },
                parents:[]
            };
        },
        mounted() {
            this.getAll();
        },
        methods: {
            async getAll() {
                let _this = this;
                let url = '/settings';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.info = response.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                _this.$root.loading = true;

                axios
                    .post("/settings/edit",data)
                    .then(function(response) {
                        _this.$root.loading = false;
                        _this.$toast.success(" تنظیمات با موفقیت ویرایش شد");
            
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
        },
    };
</script>
